/**
 *  player analytics types
 */

export enum PlayerAnalyticsType {
    DOCUMENT_IMPRESSION = 108,
    DOWNLOAD_CLICKED = 23,
}
